export const ONBOARDING_STEPS = [
  {
    id: 'welcome',
    target: null,
    title: 'Welcome to PickStar AI',
    content: 'Your intelligent sports betting assistant. Let me show you around the platform and its powerful features.',
    position: 'center',
    action: null,
  },
  {
    id: 'sports-feed',
    target: '[data-testid="sports-feed"]',
    title: 'Live Trending Games',
    content: 'Live Trending Games - More games can be found at our data hub for quick picks.',
    position: 'bottom',
    action: null,
  },
  {
    id: 'quick-actions',
    target: '.grid.grid-cols-2',
    title: 'Quick Actions',
    content: 'Access key features instantly. Start new chats, get quick picks, buy coins, view market insights, check sports hub, and browse active games.',
    position: 'top',
    mobilePosition: 'bottom', // Mobile-specific position
    action: null,
  },
  {
    id: 'quickpicks',
    target: '[data-action-id="quickpicks"]',
    title: 'QuickPicks - Fast AI Predictions',
    content: 'Get instant AI-powered betting predictions with confidence scores. Our advanced algorithms analyze real-time data to provide you with the best picks.',
    position: 'top',
    mobilePosition: 'bottom', // Mobile-specific position
    action: null,
  },
  {
    id: 'chat-navigation',
    target: '[data-action-id="chat"]',
    title: 'Deep Analysis with AI',
    content: 'Start a new chat to get detailed betting analysis, or continue from your history. Ask anything about sports, odds, strategies, and get expert AI insights.',
    position: 'top',
    mobilePosition: 'bottom', // Mobile-specific position
    action: null,
  },
  {
    id: 'history',
    target: '[data-testid="history-section"]',
    title: 'Your Chat History',
    content: 'Access your previous conversations and analyses. Review past predictions, continue discussions, and track your betting insights over time.',
    position: 'top',
    mobilePosition: 'bottom', // Force bottom position on mobile to avoid covering the element
    action: null,
  },
  {
    id: 'complete',
    target: null,
    title: 'Ready to Start',
    content: 'You are all set to explore PickStar AI. Make informed betting decisions with our AI-powered insights and comprehensive sports analysis.',
    position: 'center',
    action: null,
  }
];